module.exports = "<div class=\"info-icon-container\" (click)=\"showPopupIfInfoWithPopup();\" [ngClass]=\"{popup: bindPopup, tooltip: tooltipText}\" tooltip [content]=\"tooltipText\">\n\t<i class=\"info-icon\"></i>\n</div>\n\n<div leo-popup *ngIf=\"bindPopup\"\n\tclass=\"popup--standard-layout\"\n\t[hideCloseIcon]=\"false\"\n\t[closeableByBackdrop]=\"true\"\n\t[visible]=\"showPopup\"\n\t(cancelClicked)=\"closeInfoPopup()\"\n\tpopupTitle=\"Info\">\n\t<div>\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/leo-info/leo-info.html
// module id = oju0
// module chunks = 12